import { EventEmitter, SDK_PROMISE_ERROR, SDK_PROMISE_TIMEOUT, SdkMessageChannel, SdkRoleType, EventType } from "./base";

export default class SdkApp extends EventEmitter {
    _origin: string = location.origin;
    DEFAULT_TIMEOUT: number = 10000;
    roleType;
    iframeEle: HTMLIFrameElement | null = null;
    option: any;
    _promiseId: number = 1;

    constructor(origin: string, option: any) {
        super("sdk-app");
        if (origin) {
            this._origin = origin;
        }
        this.option = option;
        this.roleType = SdkRoleType.App;
        window.addEventListener("message", this.onMessage);
    }

    destroy() {
        window.removeEventListener("message", this.onMessage);
    }

    onMessage = async (event: MessageEvent) => {
        if ((event.origin === this._origin || "*" === this._origin) && this.roleType !== event.data.roleType) {
            switch (event.data.channel) {
                case SdkMessageChannel.PROMISE:
                    try {
                        const result = await this.onPromiseMessage(event.data);
                        this.sendMessage(event.data.key, result || undefined, event.data.promiseId, true);
                    } catch (error) {
                        this.sendMessage(
                            event.data.key,
                            {
                                type: SDK_PROMISE_ERROR,
                                code: error?.code,
                                message: error?.message || error?.msg,
                                error: error,
                            },
                            event.data.promiseId,
                            true
                        );
                    }
                    break;
                case SdkMessageChannel.REPLY:
                    this.emit(`${event.data.key}-${event.data.promiseId}`, event.data.value);
                    break;
                case SdkMessageChannel.NORMAL:
                    this.onNormalMessage(event.data);
                    this.emit(event.data.key, event.data.value);
                    break;
            }
        }
    };

    sendMessage(key: string, value: any, promiseId?: any, isReply?: boolean) {
        window.parent &&
            window.parent.postMessage(
                {
                    roleType: this.roleType,
                    channel: promiseId ? (isReply ? SdkMessageChannel.REPLY : SdkMessageChannel.PROMISE) : SdkMessageChannel.NORMAL,
                    promiseId,
                    key,
                    value,
                },
                this._origin
            );
    }

    _privatePromiseEvents = {};

    _promiseEvents: { [key: string]: Function } = {};

    get promiseEvents() {
        return { ...this._promiseEvents, ...this._privatePromiseEvents };
    }

    async onPromiseMessage(data: any) {
        const handler = this.promiseEvents[data.key];
        if (!handler) {
            throw new Error("unsupported message");
        }
        return handler(data.value);
    }

    onNormalMessage(data: any) {
        switch (data.key) {
            case EventType.INIT_CONFIG:
                this.option = data.value;
            case EventType.STOP_LOADING:
            case EventType.START_LOADING:
        }
    }

    get nextPromiseId() {
        return this._promiseId++;
    }
    postMessage(key: string, value?: any) {
        this.sendMessage(key, value);
    }

    registerPromiseEvent(event: string, handler: Function) {
        this._promiseEvents[event] = handler;
    }

    unregisterPromiseEvent(key: string) {
        this._promiseEvents[key] && delete this._promiseEvents[key];
    }

    promisePostMessage(key, value?, options?) {
        return new Promise((resolve, reject) => {
            if (!window.parent) return reject("no window parent");
            const cur = this.nextPromiseId;
            const promiseId = `${key}-${cur}`;
            const timeout = options?.timeout ?? this.option.timeout ?? this.DEFAULT_TIMEOUT;
            const timer = setTimeout(() => {
                this.off(promiseId, resolve);
                reject({
                    type: SDK_PROMISE_TIMEOUT,
                    code: 503,
                    message: `no response when timeout(${timeout})`,
                });
            }, timeout);
            this.once(promiseId, (value) => {
                clearTimeout(timer);
                if (value?.type === SDK_PROMISE_ERROR) {
                    reject(value);
                } else {
                    resolve(value);
                }
            });
            this.sendMessage(key, value, cur);
        });
    }
}
